/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description Help
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="MDI_backburger" data-name="MDI / backburger" opacity="0.6">
        <g id="Boundary" fill="#1b75bc" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_backburger" data-name="Path / backburger" d="M5,13l4,4L7.6,18.42,1.18,12,7.6,5.58,9,7,5,11H21v2H5M21,6V8H11V6H21m0,10v2H11V16Z" transform="translate(0.82 0.42)" fill="#1b75bc"/>
      </g>
    </svg>
  )
}

